import * as WpsTypes from 'DVWebNodeWpsRuntime'
import { createMergeReducer } from '../utils/reducer'
import * as actions from '../actions'
import { combineReducers, Reducer } from 'redux'
import { tuple } from '../utils/utils'

export const HEADER_DETAIL_FRAGMENT = 'headerDetail'
export const DETAIL_FRAGMENT = 'detail'
export const fragmentTypes = tuple([
  HEADER_DETAIL_FRAGMENT,
  DETAIL_FRAGMENT,
])
export type FragmentType = typeof fragmentTypes[number]
export type IDetailState = { [D in FragmentType]: TitleIdToDetail }
export type DetailFragment =
  | WpsTypes.atv.wps.DetailFragmentModelProps
  | undefined
export type TitleIdToDetail = {
  [titleId: string]: DetailFragment
}

type ReducerType = Record<
  FragmentType,
  Reducer<TitleIdToDetail, actions.DetailPageActions>
  >

const initialState = {} as TitleIdToDetail

const createDetailReducer = (fragment: FragmentType) =>
  createMergeReducer(
    t => t.detail && t.detail[fragment],
    initialState
  )

export const reducer = combineReducers<IDetailState, actions.DetailPageActions>(
  fragmentTypes.reduce(
    (acc, fragment) => {
      acc[fragment] = createDetailReducer(fragment)
      return acc
    },
    {} as Partial<ReducerType>
  ) as ReducerType
)